/**
 * GENERATED FILE — do not edit by hand.
 * Source: tools/generate-notices.mjs, from the installed dependency tree.
 * Run `npm run notices` after changing any dependency.
 */

export interface Notice {
  readonly name: string;
  readonly version: string;
  readonly license: string;
  readonly homepage: string | null;
}

export const NOTICES: readonly Notice[] = [
  {
    "name": "@nodable/entities",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "git+https://github.com/nodable/val-parsers.git"
  },
  {
    "name": "@pdf-lib/standard-fonts",
    "version": "1.0.0",
    "license": "MIT",
    "homepage": "https://github.com/Hopding/standard-fonts"
  },
  {
    "name": "@pdf-lib/upng",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "https://github.com/Hopding/upng"
  },
  {
    "name": "anynum",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "https://github.com/NaturalIntelligence/anynum"
  },
  {
    "name": "fast-xml-builder",
    "version": "1.3.0",
    "license": "MIT",
    "homepage": "git+https://github.com/NaturalIntelligence/fast-xml-builder.git"
  },
  {
    "name": "fast-xml-parser",
    "version": "5.10.1",
    "license": "MIT",
    "homepage": "git+https://github.com/NaturalIntelligence/fast-xml-parser.git"
  },
  {
    "name": "fflate",
    "version": "0.8.3",
    "license": "MIT",
    "homepage": "https://101arrowz.github.io/fflate"
  },
  {
    "name": "is-unsafe",
    "version": "2.0.0",
    "license": "MIT",
    "homepage": "https://github.com/NaturalIntelligence/is-unsafe"
  },
  {
    "name": "pako",
    "version": "1.0.11",
    "license": "(MIT AND Zlib)",
    "homepage": "https://github.com/nodeca/pako"
  },
  {
    "name": "path-expression-matcher",
    "version": "1.6.2",
    "license": "MIT",
    "homepage": "https://github.com/NaturalIntelligence/path-expression-matcher#readme"
  },
  {
    "name": "pdf-lib",
    "version": "1.17.1",
    "license": "MIT",
    "homepage": "https://pdf-lib.js.org"
  },
  {
    "name": "pdfjs-dist",
    "version": "6.1.200",
    "license": "Apache-2.0",
    "homepage": "https://mozilla.github.io/pdf.js/"
  },
  {
    "name": "react",
    "version": "19.2.8",
    "license": "MIT",
    "homepage": "https://react.dev/"
  },
  {
    "name": "react-dom",
    "version": "19.2.8",
    "license": "MIT",
    "homepage": "https://react.dev/"
  },
  {
    "name": "scheduler",
    "version": "0.27.0",
    "license": "MIT",
    "homepage": "https://react.dev/"
  },
  {
    "name": "strnum",
    "version": "2.4.1",
    "license": "MIT",
    "homepage": "https://github.com/NaturalIntelligence/strnum"
  },
  {
    "name": "tslib",
    "version": "1.14.1",
    "license": "0BSD",
    "homepage": "https://www.typescriptlang.org/"
  },
  {
    "name": "xml-naming",
    "version": "0.3.0",
    "license": "MIT",
    "homepage": "https://github.com/NaturalIntelligence/xml-naming"
  }
];

/** Distinct licences, most common first — what the summary line reports. */
export const LICENSE_COUNTS: readonly (readonly [string, number])[] = [
  [
    "MIT",
    15
  ],
  [
    "(MIT AND Zlib)",
    1
  ],
  [
    "Apache-2.0",
    1
  ],
  [
    "0BSD",
    1
  ]
];
